import $ from 'jquery';

export const init = () => {
	const switchToggle = $('#errorToggle');
	const switchLabel = $('.js-switch-label');
	const title = $('.js-error-title');
	const subTitle = $('.js-error-sub-title');
	const switchToggleOn = $('.js-toggle-on');
	const switchToggleOff = $('.js-toggle-off');
	const errorBody = $('.js-error-body');
	const countdown = $('.js-countdown');
	const countdownVal = $('.js-countdown-value');
	const errorRedirect = $('.js-error-redirect');

	const INTERVAL = 1000;
	let timeLeft = countdownVal.data('timeLeft');
	let secondaryText = title.data('secondaryText');

	const countdownTimer = () =>
		setInterval(() => {
			if (timeLeft <= 0) {
				clearInterval(countdownTimer);
				countdownVal.html(0);
				if (errorRedirect.length > 0) {
					window.location.replace(errorRedirect.data('redirectUrl'));
				} else {
					window.location.replace('/');
				}
			} else {
				countdownVal.html(timeLeft);
			}
			timeLeft -= 1;
		}, INTERVAL);

	function setInitCountdown() {
		countdownVal.html(timeLeft);
	}

	function handleChangeSecondaryText(event) {
		event.preventDefault();

		if ($(event.currentTarget).is(':checked')) {
			setTimeout(function () {
				subTitle.addClass('is-hidden');
				subTitle.attr('aria-hidden', true);
				countdown.addClass('is-active');
				countdown.removeAttr('aria-hidden');
			}, 540);
		}
	}

	function handleChangePrimaryText(event) {
		event.preventDefault();

		if ($(event.currentTarget).is(':checked')) {
			title.fadeOut(function () {
				title.text(secondaryText).fadeIn();
			});
		}
	}

	function handleChangeColor(event) {
		event.preventDefault();

		if ($(event.currentTarget).is(':checked')) {
			setTimeout(function () {
				switchToggleOn.removeAttr('aria-hidden');
				switchToggleOn.addClass('is-active');
				switchToggleOff.attr('aria-hidden', true);
				switchToggleOff.addClass('is-hidden');
			}, 525);

			setTimeout(function () {
				errorBody.removeClass('u-bg-red');
				errorBody.addClass('u-bg-turquoise');
			}, 540);
		}
	}

	switchToggle.on('change', function (e) {
		$(this).closest(switchLabel).addClass('is-disabled');
		$(this).closest(switchLabel).attr('aria-disabled', true);
		$(this).attr('aria-checked', true);
		handleChangePrimaryText(e);
		handleChangeColor(e);
		handleChangeSecondaryText(e);
		setInitCountdown();
		countdownTimer();
	});
};
